module.exports = __webpack_public_path__ + "static/media/Peer_authoring.ee9db5af.jpg";